import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    type: "",
    text: "",
    sort: "",
};

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        filterByType: (state, action) => {
            state.type = action.payload;
        },
        searchByTitle: (state, action) => {
            state.text = action.payload;
        },
        sortBySalary: (state, action) => {
            state.sort = action.payload;
        },
    },
});

export default filterSlice.reducer;
export const { filterByType, searchByTitle, sortBySalary } =
    filterSlice.actions;
